
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/andon",
      function () {
        return require("private-next-pages/andon/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/andon"])
      });
    }
  